import Component from './Favicon.component';

export default Component;
